import { render, staticRenderFns } from "./MultipleTabsError.vue?vue&type=template&id=6355d709&"
import script from "./MultipleTabsError.vue?vue&type=script&lang=ts&"
export * from "./MultipleTabsError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports